import { v4 as uuidv4 } from 'uuid';

export const AuthConfig = [
  {
    title: 'Overview',
    uuid: uuidv4(),
    data: [
      {
        title: '7-Day Money Back Guarantee',
        uuid: uuidv4(),
        tips: "If you're not 100% satisfied with your paid subscription plan in your first 7 days, you can cancel at any time to receive a full refund.",
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'User Management',
        uuid: uuidv4(),
        tips: 'Conveniently add, edit, and remove users in your account.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
    ],
  },
  {
    title: 'Streaming',
    uuid: uuidv4(),
    data: [
      {
        title: 'Unlimited Viewers',
        uuid: uuidv4(),
        tips: 'Each of our streaming plans includes at least 10,000 viewer hours a month and no limit on the number of viewers.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Unlimited Streaming',
        uuid: uuidv4(),
        tips: 'Stream all of your events with no limit on the number of events you host.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Video Resolution',
        uuid: uuidv4(),
        tips: 'Deliver high-quality video with resolution up to 1080p.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
            text: 'Up to 1080P',
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
            text: 'Up to 1080P',
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
            text: 'Up to 1080P',
          },
        ],
      },
      {
        title: 'Automated Scheduling',
        uuid: uuidv4(),
        tips: 'Eliminate the task of starting and ending your event with preset scheduling.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Advanced Scheduling',
        uuid: uuidv4(),
        tips: 'Save time and plan ahead by scheduling events days or weeks before you go live. Set recurring events or upload your events in bulk.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Team Members',
        uuid: uuidv4(),
        tips: 'Give access to your whole production team with no user limits on your account.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
            text: 'Unlimited',
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
            text: 'Unlimited',
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
            text: 'Unlimited',
          },
        ],
      },
      {
        title: 'Maximum Event Duration',
        uuid: uuidv4(),
        tips: 'Stream your event for up to 24 consecutive hours.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
            text: '24 Hours',
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
            text: '24 Hours',
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
            text: '24 Hours',
          },
        ],
      },
      {
        title: 'Ad Free',
        uuid: uuidv4(),
        tips: "Own your content and don't expose your viewers to uncontrollable third-party advertisements.",
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Cloud Transcoding',
        uuid: uuidv4(),
        tips: 'Remove bandwidth burdens by streaming a single source to the cloud.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Concurrent Events',
        uuid: uuidv4(),
        tips: 'Account for overlapping events by streaming multiple events simultaneously.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
            text: 'Unlimited',
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
            text: 'Unlimited',
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
            text: 'Unlimited',
          },
        ],
      },
      {
        title: 'Simulated Live',
        uuid: uuidv4(),
        tips: 'Reach audiences who couldn’t tune in live by re-event recorded or uploaded events to any destination at any time.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Encoder Management',
        uuid: uuidv4(),
        tips: 'Track and control all of your encoders from anywhere via the YoloCast.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
    ],
  },
  {
    title: 'Destinations',
    uuid: uuidv4(),
    data: [
      {
        title: 'Stream to Your Website',
        uuid: uuidv4(),
        tips: "Control your organization's brand by sending your stream directly to your own website with a customizable player.",
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Stream to Facebook Live',
        uuid: uuidv4(),
        tips: 'Reach your Facebook audience by streaming simultaneously to Facebook Live.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Stream to YouTube',
        uuid: uuidv4(),
        tips: 'Reach your YouTube audience by streaming simultaneously to YouTube.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Stream to Twitch',
        uuid: uuidv4(),
        tips: 'Reach your Twitter audience by streaming simultaneously to Twitch.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Stream to Twitter',
        secondTitle: '(COMING SOON)',
        uuid: uuidv4(),
        tips: 'Reach your Twitter audience by streaming simultaneously to Twitter.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Stream to any RTMP Destination',
        uuid: uuidv4(),
        tips: 'Reach your audiences on other platforms by streaming simultaneously to any RTMP destination.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
    ],
  },
  {
    title: 'Media Center',
    uuid: uuidv4(),
    data: [
      {
        title: 'Storage',
        uuid: uuidv4(),
        tips: 'Store event playback and media materials',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
            text: '500 GB',
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
            text: '1 TB',
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
            text: '2 TB',
          },
        ],
      },
    ],
  },
  {
    title: 'Support + Montoring',
    uuid: uuidv4(),
    data: [
      {
        title: 'Email Support',
        uuid: uuidv4(),
        tips: 'Our team are here to help by email, during working day.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: '24/7 Support',
        secondTitle: '(COMING SOON)',
        uuid: uuidv4(),
        tips: 'Our team are here to help by chat or phone, 24/7.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Mobile Monitoring',
        uuid: uuidv4(),
        tips: 'Monitor all of your events from anywhere through our HTML5 pages.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
    ],
  },
  {
    title: 'Analytics',
    uuid: uuidv4(),
    data: [
      {
        title: 'Real-time Analytics',
        uuid: uuidv4(),
        tips: 'View your audience data in real time when streaming.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Viewer Engagement Stats',
        uuid: uuidv4(),
        tips: 'Understand your reach with engagement graphs and data on total views, unique viewers, and average view duration.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Viewer Insights',
        uuid: uuidv4(),
        tips: 'See where in the world your viewers are watching, with a live, interactive map.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Geo-Analytics',
        uuid: uuidv4(),
        tips: 'Take a detailed look at how viewers watch your content with data on viewing destinations, devices, and playback quality.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Google Analytics Integration',
        secondTitle: '(COMING SOON)',
        uuid: uuidv4(),
        tips: 'Linking your Google Analytics to your YoloCast account to collect more data on your streaming video traffic and enhance the built-in YoloCast analytics.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
    ],
  },
  {
    title: 'Video Player',
    uuid: uuidv4(),
    data: [
      {
        title: 'Social Sharing',
        uuid: uuidv4(),
        tips: 'Let your viewers promote your streams with easy social media sharing.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Mobile-Friendly Player',
        uuid: uuidv4(),
        tips: 'Deliver a great viewer experience on phones, tablets, or computers with a responsive HTML5 player.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Live DVR',
        uuid: uuidv4(),
        tips: "Allow your viewers to restart or jump to specific points in your event while it's still live.",
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Countdown Timer',
        uuid: uuidv4(),
        tips: "Let viewers know when you'll be going live by displaying a countdown on top of the embedded player.",
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Channels',
        secondTitle: '(COMING SOON)',
        uuid: uuidv4(),
        tips: 'Organize your events by categorizing them into customizable, embeddable channels.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Adaptive Bitrate Playback',
        secondTitle: '(COMING SOON)',
        uuid: uuidv4(),
        tips: 'Ensure buffer-less playback with automatic resolution optimization for various viewer watching conditions.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
    ],
  },
  {
    title: 'Video Management',
    uuid: uuidv4(),
    data: [
      {
        title: 'Downloading + Exporting',
        uuid: uuidv4(),
        tips: 'Download audio or video of your events.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Audio Downloads',
        uuid: uuidv4(),
        tips: 'Create podcasts and other audio content by downloading an audio version of your recorded events.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'RSS Feeds for Third-Party Applications',
        secondTitle: '(COMING SOON)',
        uuid: uuidv4(),
        tips: 'Extend the reach of your content by syndicating video and audio from your events with automatically generated RSS and MRSS feeds.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Automatic Recording',
        uuid: uuidv4(),
        tips: 'Let viewers watch your automatically recorded events using the same links and embeds.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Trimming',
        uuid: uuidv4(),
        tips: 'Cut out dead time by trimming the beginning and ends from your event.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Event Replacements',
        uuid: uuidv4(),
        tips: 'Showcase the best version by replacing live events with post-produced video without changing links, embeds, or analytics.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Highlight Clipping',
        uuid: uuidv4(),
        tips: 'Capture important moments and share them on social media by quickly clipping highlights mid-event or after your event is over.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
    ],
  },
  {
    title: 'Viewer Experience',
    uuid: uuidv4(),
    data: [
      {
        title: 'Viewer Chat',
        uuid: uuidv4(),
        tips: 'Boost viewer engagement by facilitating conversations during your live streams.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Graphic Overlays',
        uuid: uuidv4(),
        tips: 'Enhance your event with graphics like logos, watermarks, lower thirds, full-screen overlays, or basic ads.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Automated Captioning',
        uuid: uuidv4(),
        tips: 'Save time, adhere to compliance standards, and make your recorded events more accessible by automatically adding closed captions.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Document Display',
        uuid: uuidv4(),
        tips: 'Provide your online viewers with a PDF version of the same documents you share in person, right beside your live stream.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Video Markers',
        uuid: uuidv4(),
        tips: 'Help viewers easily find significant moments by naming and tagging points in a recorded event.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'White-Labeled Embed',
        uuid: uuidv4(),
        tips: 'Present a cleaner viewer experience that removes “YoloLiv”logo from the embedded player.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'High Frame Rate (Up to 60fps)',
        uuid: uuidv4(),
        tips: 'Capture motion fluidly by streaming with frame rates up to 60 fps.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Manual Scoreboard Overlay',
        uuid: uuidv4(),
        tips: 'Overlay a live scoreboard on your event. Control the scoreboard on your computer, phone, or tablet.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Pre-Event Video',
        secondTitle: '(COMING SOON)',
        uuid: uuidv4(),
        tips: 'Engage your viewers before your event begins, with a looping video on the player when you’re not live.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
    ],
  },
  {
    title: 'Privacy + Security',
    uuid: uuidv4(),
    data: [
      {
        title: 'Private Events',
        uuid: uuidv4(),
        tips: 'Restrict stream access by creating private events sharable only via link.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Password Protection',
        uuid: uuidv4(),
        tips: 'Protect your events with a single, secure password.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Geo-Blocking',
        secondTitle: '(COMING SOON)',
        uuid: uuidv4(),
        tips: 'Restrict viewership geographically based on zip code or point and radius.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Embedding Restrictions',
        uuid: uuidv4(),
        tips: 'Maintain control of your content by limiting the destinations or URLs where the event can be watched.',
        data: [
          {
            title: 'Trial',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
    ],
  },
  {
    title: 'Video Monetization',
    uuid: uuidv4(),
    data: [
      {
        title: 'Donations',
        secondTitle: '(COMING SOON)',
        uuid: uuidv4(),
        tips: 'Accept donations for your organization. Includes 3% processing fee.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
      {
        title: 'Ticketing',
        secondTitle: '(COMING SOON)',
        uuid: uuidv4(),
        tips: 'Allows viewers with either a pay-per-view video.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
        ],
      },
    ],
  },
];

export const AddOnsAuthConfig = [
  {
    title: 'Add-Ons',
    uuid: uuidv4(),
    data: [
      {
        title: 'Simulated Live',
        uuid: uuidv4(),
        tips: 'Reach audiences who couldn’t tune in live by re-event recorded or uploaded events to any destination at any time.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Monthly Price',
            auth: true,
            uuid: uuidv4(),
            text: '$5',
            textS: '$25',
            textSymbol: '/mo',
          },
        ],
      },
      {
        title: 'Highlight Clipping',
        uuid: uuidv4(),
        tips: 'Capture important moments and share them on social media by quickly clipping highlights mid-event or after your event is over.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Monthly Price',
            auth: true,
            uuid: uuidv4(),
            text: '$5',
            textS: '$25',
            textSymbol: '/mo',
          },
        ],
      },
      {
        title: 'Document Display',
        uuid: uuidv4(),
        tips: 'Provide your online viewers with a PDF version of the same documents you share in person, right beside your live stream.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Monthly Price',
            auth: true,
            uuid: uuidv4(),
            text: '$5',
            textS: '$25',
            textSymbol: '/mo',
          },
        ],
      },
      {
        title: 'Video Markers',
        uuid: uuidv4(),
        tips: 'Help viewers easily find significant moments by naming and tagging points in a recorded event.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Monthly Price',
            auth: true,
            uuid: uuidv4(),
            text: '$5',
            textS: '$25',
            textSymbol: '/mo',
          },
        ],
      },
      {
        title: 'White-Labeled Embed',
        uuid: uuidv4(),
        tips: 'Present a cleaner viewer experience that removes “YoloLiv”logo from the embedded player.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Monthly Price',
            auth: true,
            uuid: uuidv4(),
            text: '$5',
            textS: '$25',
            textSymbol: '/mo',
          },
        ],
      },
      {
        title: 'Graphic Overlays',
        uuid: uuidv4(),
        tips: 'Enhance your event with graphics like logos, watermarks, lower thirds, full-screen overlays, or basic ads.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Monthly Price',
            auth: true,
            uuid: uuidv4(),
            text: '$10',
            textS: '$25',
            textSymbol: '/mo',
          },
        ],
      },
      {
        title: 'Automated Captioning',
        uuid: uuidv4(),
        tips: 'Save time, adhere to compliance standards, and make your recorded events more accessible by automatically adding closed captions.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Monthly Price',
            auth: true,
            uuid: uuidv4(),
            text: '$10',
            textS: '$25',
            textSymbol: '/mo',
          },
        ],
      },
      {
        title: 'High Frame Rate (Up to 60fps)',
        uuid: uuidv4(),
        tips: 'Capture motion fluidly by streaming with frame rates up to 60 fps.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Monthly Price',
            auth: true,
            uuid: uuidv4(),
            text: '$10',
            textS: '$25',
            textSymbol: '/mo',
          },
        ],
      },
      {
        title: 'Manual Scoreboard Overlay',
        uuid: uuidv4(),
        tips: 'Overlay a live scoreboard on your event. Control the scoreboard on your computer, phone, or tablet.',
        data: [
          {
            title: 'Trial',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Essential',
            auth: false,
            uuid: uuidv4(),
          },
          {
            title: 'Growth',
            auth: true,
            uuid: uuidv4(),
          },
          {
            title: 'Monthly Price',
            auth: true,
            uuid: uuidv4(),
            text: '$10',
            textS: '$25',
            textSymbol: '/mo',
          },
        ],
      },
    ],
  },
];

export const countryList = [
  { name: 'Afghanistan', code: 'AF' },
  { name: 'Åland Islands', code: 'AX' },
  { name: 'Albania', code: 'AL' },
  { name: 'Algeria', code: 'DZ' },
  { name: 'American Samoa', code: 'AS' },
  { name: 'Andorra', code: 'AD' },
  { name: 'Angola', code: 'AO' },
  { name: 'Anguilla', code: 'AI' },
  { name: 'Antarctica', code: 'AQ' },
  { name: 'Antigua and Barbuda', code: 'AG' },
  { name: 'Argentina', code: 'AR' },
  { name: 'Armenia', code: 'AM' },
  { name: 'Aruba', code: 'AW' },
  { name: 'Australia', code: 'AU' },
  { name: 'Austria', code: 'AT' },
  { name: 'Azerbaijan', code: 'AZ' },
  { name: 'Bahamas', code: 'BS' },
  { name: 'Bahrain', code: 'BH' },
  { name: 'Bangladesh', code: 'BD' },
  { name: 'Barbados', code: 'BB' },
  { name: 'Belarus', code: 'BY' },
  { name: 'Belgium', code: 'BE' },
  { name: 'Belize', code: 'BZ' },
  { name: 'Benin', code: 'BJ' },
  { name: 'Bermuda', code: 'BM' },
  { name: 'Bhutan', code: 'BT' },
  { name: 'Bolivia', code: 'BO' },
  { name: 'Bosnia and Herzegovina', code: 'BA' },
  { name: 'Botswana', code: 'BW' },
  { name: 'Bouvet Island', code: 'BV' },
  { name: 'Brazil', code: 'BR' },
  { name: 'British Indian Ocean Territory', code: 'IO' },
  { name: 'Brunei Darussalam', code: 'BN' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Burkina Faso', code: 'BF' },
  { name: 'Burundi', code: 'BI' },
  { name: 'Cambodia', code: 'KH' },
  { name: 'Cameroon', code: 'CM' },
  { name: 'Canada', code: 'CA' },
  { name: 'Cape Verde', code: 'CV' },
  { name: 'Cayman Islands', code: 'KY' },
  { name: 'Central African Republic', code: 'CF' },
  { name: 'Chad', code: 'TD' },
  { name: 'Chile', code: 'CL' },
  { name: 'China', code: 'CN' },
  { name: 'Christmas Island', code: 'CX' },
  { name: 'Cocos (Keeling) Islands', code: 'CC' },
  { name: 'Colombia', code: 'CO' },
  { name: 'Comoros', code: 'KM' },
  { name: 'Congo', code: 'CG' },
  { name: 'Congo, The Democratic Republic of the', code: 'CD' },
  { name: 'Cook Islands', code: 'CK' },
  { name: 'Costa Rica', code: 'CR' },
  { name: "Cote D'Ivoire", code: 'CI' },
  { name: 'Croatia', code: 'HR' },
  { name: 'Cuba', code: 'CU' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Czech Republic', code: 'CZ' },
  { name: 'Denmark', code: 'DK' },
  { name: 'Djibouti', code: 'DJ' },
  { name: 'Dominica', code: 'DM' },
  { name: 'Dominican Republic', code: 'DO' },
  { name: 'Ecuador', code: 'EC' },
  { name: 'Egypt', code: 'EG' },
  { name: 'El Salvador', code: 'SV' },
  { name: 'Equatorial Guinea', code: 'GQ' },
  { name: 'Eritrea', code: 'ER' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Ethiopia', code: 'ET' },
  { name: 'Falkland Islands (Malvinas)', code: 'FK' },
  { name: 'Faroe Islands', code: 'FO' },
  { name: 'Fiji', code: 'FJ' },
  { name: 'Finland', code: 'FI' },
  { name: 'France', code: 'FR' },
  { name: 'French Guiana', code: 'GF' },
  { name: 'French Polynesia', code: 'PF' },
  { name: 'French Southern Territories', code: 'TF' },
  { name: 'Gabon', code: 'GA' },
  { name: 'Gambia', code: 'GM' },
  { name: 'Georgia', code: 'GE' },
  { name: 'Germany', code: 'DE' },
  { name: 'Ghana', code: 'GH' },
  { name: 'Gibraltar', code: 'GI' },
  { name: 'Greece', code: 'GR' },
  { name: 'Greenland', code: 'GL' },
  { name: 'Grenada', code: 'GD' },
  { name: 'Guadeloupe', code: 'GP' },
  { name: 'Guam', code: 'GU' },
  { name: 'Guatemala', code: 'GT' },
  { name: 'Guernsey', code: 'GG' },
  { name: 'Guinea', code: 'GN' },
  { name: 'Guinea-Bissau', code: 'GW' },
  { name: 'Guyana', code: 'GY' },
  { name: 'Haiti', code: 'HT' },
  { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
  { name: 'Holy See (Vatican City State)', code: 'VA' },
  { name: 'Honduras', code: 'HN' },
  { name: 'Hong Kong', code: 'HK' },
  { name: 'Hungary', code: 'HU' },
  { name: 'Iceland', code: 'IS' },
  { name: 'India', code: 'IN' },
  { name: 'Indonesia', code: 'ID' },
  { name: 'Iran, Islamic Republic Of', code: 'IR' },
  { name: 'Iraq', code: 'IQ' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Isle of Man', code: 'IM' },
  { name: 'Israel', code: 'IL' },
  { name: 'Italy', code: 'IT' },
  { name: 'Jamaica', code: 'JM' },
  { name: 'Japan', code: 'JP' },
  { name: 'Jersey', code: 'JE' },
  { name: 'Jordan', code: 'JO' },
  { name: 'Kazakhstan', code: 'KZ' },
  { name: 'Kenya', code: 'KE' },
  { name: 'Kiribati', code: 'KI' },
  { name: "Korea, Democratic People's Republic of", code: 'KP' },
  { name: 'Korea, Republic of', code: 'KR' },
  { name: 'Kuwait', code: 'KW' },
  { name: 'Kyrgyzstan', code: 'KG' },
  { name: "Lao People's Democratic Republic", code: 'LA' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Lebanon', code: 'LB' },
  { name: 'Lesotho', code: 'LS' },
  { name: 'Liberia', code: 'LR' },
  { name: 'Libyan Arab Jamahiriya', code: 'LY' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Luxembourg', code: 'LU' },
  { name: 'Macao', code: 'MO' },
  { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
  { name: 'Madagascar', code: 'MG' },
  { name: 'Malawi', code: 'MW' },
  { name: 'Malaysia', code: 'MY' },
  { name: 'Maldives', code: 'MV' },
  { name: 'Mali', code: 'ML' },
  { name: 'Malta', code: 'MT' },
  { name: 'Marshall Islands', code: 'MH' },
  { name: 'Martinique', code: 'MQ' },
  { name: 'Mauritania', code: 'MR' },
  { name: 'Mauritius', code: 'MU' },
  { name: 'Mayotte', code: 'YT' },
  { name: 'Mexico', code: 'MX' },
  { name: 'Micronesia, Federated States of', code: 'FM' },
  { name: 'Moldova, Republic of', code: 'MD' },
  { name: 'Monaco', code: 'MC' },
  { name: 'Mongolia', code: 'MN' },
  { name: 'Montserrat', code: 'MS' },
  { name: 'Morocco', code: 'MA' },
  { name: 'Mozambique', code: 'MZ' },
  { name: 'Myanmar', code: 'MM' },
  { name: 'Namibia', code: 'NA' },
  { name: 'Nauru', code: 'NR' },
  { name: 'Nepal', code: 'NP' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'Netherlands Antilles', code: 'AN' },
  { name: 'New Caledonia', code: 'NC' },
  { name: 'New Zealand', code: 'NZ' },
  { name: 'Nicaragua', code: 'NI' },
  { name: 'Niger', code: 'NE' },
  { name: 'Nigeria', code: 'NG' },
  { name: 'Niue', code: 'NU' },
  { name: 'Norfolk Island', code: 'NF' },
  { name: 'Northern Mariana Islands', code: 'MP' },
  { name: 'Norway', code: 'NO' },
  { name: 'Oman', code: 'OM' },
  { name: 'Pakistan', code: 'PK' },
  { name: 'Palau', code: 'PW' },
  { name: 'Palestinian Territory, Occupied', code: 'PS' },
  { name: 'Panama', code: 'PA' },
  { name: 'Papua New Guinea', code: 'PG' },
  { name: 'Paraguay', code: 'PY' },
  { name: 'Peru', code: 'PE' },
  { name: 'Philippines', code: 'PH' },
  { name: 'Pitcairn', code: 'PN' },
  { name: 'Poland', code: 'PL' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Puerto Rico', code: 'PR' },
  { name: 'Qatar', code: 'QA' },
  { name: 'Reunion', code: 'RE' },
  { name: 'Romania', code: 'RO' },
  { name: 'Russian Federation', code: 'RU' },
  { name: 'Rwanda', code: 'RW' },
  { name: 'Saint Helena', code: 'SH' },
  { name: 'Saint Kitts and Nevis', code: 'KN' },
  { name: 'Saint Lucia', code: 'LC' },
  { name: 'Saint Pierre and Miquelon', code: 'PM' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC' },
  { name: 'Samoa', code: 'WS' },
  { name: 'San Marino', code: 'SM' },
  { name: 'Sao Tome and Principe', code: 'ST' },
  { name: 'Saudi Arabia', code: 'SA' },
  { name: 'Senegal', code: 'SN' },
  { name: 'Serbia and Montenegro', code: 'CS' },
  { name: 'Seychelles', code: 'SC' },
  { name: 'Sierra Leone', code: 'SL' },
  { name: 'Singapore', code: 'SG' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Solomon Islands', code: 'SB' },
  { name: 'Somalia', code: 'SO' },
  { name: 'South Africa', code: 'ZA' },
  { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
  { name: 'Spain', code: 'ES' },
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'Sudan', code: 'SD' },
  { name: 'Suriname', code: 'SR' },
  { name: 'Svalbard and Jan Mayen', code: 'SJ' },
  { name: 'Swaziland', code: 'SZ' },
  { name: 'Sweden', code: 'SE' },
  { name: 'Switzerland', code: 'CH' },
  { name: 'Syrian Arab Republic', code: 'SY' },
  { name: 'Taiwan, Province of China', code: 'TW' },
  { name: 'Tajikistan', code: 'TJ' },
  { name: 'Tanzania, United Republic of', code: 'TZ' },
  { name: 'Thailand', code: 'TH' },
  { name: 'Timor-Leste', code: 'TL' },
  { name: 'Togo', code: 'TG' },
  { name: 'Tokelau', code: 'TK' },
  { name: 'Tonga', code: 'TO' },
  { name: 'Trinidad and Tobago', code: 'TT' },
  { name: 'Tunisia', code: 'TN' },
  { name: 'Turkey', code: 'TR' },
  { name: 'Turkmenistan', code: 'TM' },
  { name: 'Turks and Caicos Islands', code: 'TC' },
  { name: 'Tuvalu', code: 'TV' },
  { name: 'Uganda', code: 'UG' },
  { name: 'Ukraine', code: 'UA' },
  { name: 'United Arab Emirates', code: 'AE' },
  { name: 'United Kingdom', code: 'GB' },
  { name: 'United States', code: 'US' },
  { name: 'United States Minor Outlying Islands', code: 'UM' },
  { name: 'Uruguay', code: 'UY' },
  { name: 'Uzbekistan', code: 'UZ' },
  { name: 'Vanuatu', code: 'VU' },
  { name: 'Venezuela', code: 'VE' },
  { name: 'Vietnam', code: 'VN' },
  { name: 'Virgin Islands, British', code: 'VG' },
  { name: 'Virgin Islands, U.S.', code: 'VI' },
  { name: 'Wallis and Futuna', code: 'WF' },
  { name: 'Western Sahara', code: 'EH' },
  { name: 'Yemen', code: 'YE' },
  { name: 'Zambia', code: 'ZM' },
  { name: 'Zimbabwe', code: 'ZW' },
];
